export const ADD_TO_CART_MUTATION = `
  mutation AddToCart($product_id: ID!, $variant_id: String, $quantity: Int!) {
    addToCart(product_id: $product_id, variant_id: $variant_id, quantity: $quantity) {
      success
      message
      cart {
        product_id
        variant_id
        name
        quantity
        price
        __typename
      }
    }
  }
`;
